import CellPanel from './CellPanel.vue';
export default CellPanel;
